const TYPES = ['all', 'active', 'completed'];

export { TYPES };
